module.exports = __webpack_public_path__ + "static/img/6961_phase_function_Paper_Points.7a56547.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6961_phase_function_Paper_Points.png
// module id = GtVS
// module chunks = 0